import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import raDataDownloaderWorker from "../../workers/raDataDownloaderWorker";
import WebWorker from "../../workers/WebWorker";

const createCleaningAdvisorExcelSheet = (
  workbook,
  sheetData,
  columns,
  sheetName,
  t,
  transposeData = false
) => {
  const excelSheet = workbook.addWorksheet(sheetName);
  if (sheetData) {
    if (transposeData) {
      if (columns.length === sheetData.length) {
        for (let i = 0; i < columns.length; i++) {
          const row = excelSheet.addRow([columns[i], sheetData[i]]);
          row.getCell(1).font = { bold: true };
          row.getCell(2).alignment = { horizontal: "right" };
        }
        excelSheet.getColumn(1).width = 50;
      }
    } else {
      excelSheet.getRow(1).font = { bold: true };
      excelSheet.columns = Object.keys(columns).map((key) => ({
        key,
        header: columns[key],
        width: 20,
      }));
      excelSheet.addRows(sheetData);
    }
  }
  if (sheetName === t("excelSheetNames.others")) {
    const dividerRow1 = excelSheet.insertRow(34);
    const dividerRow = excelSheet.insertRow(35);
    const dividerRow2 = excelSheet.insertRow(36);
    dividerRow.height = 30;
    const dividerCell = dividerRow.getCell("A");
    dividerCell.value = "Advance Settings";
    dividerCell.font = { bold: true, size: 14 };
    dividerRow.border = {
      top: { style: "medium", color: { argb: "FFD3D3D3" } },
      bottom: { style: "medium", color: { argb: "FFD3D3D3" } },
    };
  }
};

const transposeData = (data) => {
  const transposedData = Object.keys(data[0])
    .map((key) => data.map((row) => row[key]))
    .flat();

  return transposedData;
};
const transposeColumns = (columns, otherSheetData) => {
  const permeate_quality = otherSheetData[0]["permeate"];
  const pressure = otherSheetData[0]["pressure"];
  const flow = otherSheetData[0]["flow"];
  return Object.keys(columns).map((key) => {
    let column = columns[key];
    if (columns[key].includes("Flow")) {
      column = column.replace("<unit>", flow);
    } else if (
      columns[key].includes("设计的产水流量") ||
      columns[key].includes("最小产水流量")
    ) {
      column = column.replace("<unit>", flow);
    } else if (columns[key].includes("最差产水水质")) {
      column = column.replace("<unit>", permeate_quality);
    } else if (columns[key].includes("Permeate")) {
      column = column.replace("<unit>", permeate_quality);
    } else if (
      columns[key].includes("最大进水压力") ||
      columns[key].includes("初始压差") ||
      columns[key].includes("最大压差")
    ) {
      column = column.replace("<unit>", pressure);
    } else if (columns[key].includes("Pressure")) {
      column = column.replace("<unit>", pressure);
    }
    return column;
  });
};

const saveExcelFile = async (exportAllSheetName, workbook) => {
  const fileName = exportAllSheetName;
  const buffer = await workbook.xlsx.writeBuffer();
  const excelData = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(excelData, fileName);
};

export const exportAllReplacementTables = async (
  exportAllSheetName,
  exportData,
  translatedRowData,
  t
) => {
  const worker = new WebWorker(raDataDownloaderWorker);

  const translations = {
    exportWorkerTransaltionString: t("exportWorkerTransaltionString", {
      returnObjects: true,
    }),
  };
  worker.postMessage({ exportData, translations, translatedRowData });
  worker.onerror = (error) => console.log("Error in Worker:", error);
  worker.onmessage = (event) => {
    const {
      replacementAnalysisSheetData,
      otherSheetData,
      replacementPredictionSheetData,
    } = event.data;

    const workbook = new ExcelJS.Workbook();

    const ReplacementAnalysisStringsObj = t("ReplacementAnalysisStrings", {
      returnObjects: true,
    });
    createCleaningAdvisorExcelSheet(
      workbook,
      replacementAnalysisSheetData,
      ReplacementAnalysisStringsObj,
      t("excelSheetNames.replacementAnalysis"),
      t
    );
    const ReplacementPredictionStringsObj = t("ReplacementPredictionStrings", {
      returnObjects: true,
    });
    createCleaningAdvisorExcelSheet(
      workbook,
      replacementPredictionSheetData,
      ReplacementPredictionStringsObj,
      t("excelSheetNames.prediction"),
      t
    );

    const OthersTableStringsObj = t("RAOthersTableStrings", {
      returnObjects: true,
    });
    const transposedOtherSheetData = transposeData(otherSheetData);
    const transposedOtherSheetColumn = transposeColumns(
      OthersTableStringsObj,
      otherSheetData
    );

    createCleaningAdvisorExcelSheet(
      workbook,
      transposedOtherSheetData,
      transposedOtherSheetColumn,
      t("excelSheetNames.others"),
      t,
      true
    );

    saveExcelFile(exportAllSheetName, workbook);
    worker.terminate();
  };
};

export default exportAllReplacementTables;
